import axios from '@/libs/api.request'

export const getsysparameterList = (key, value) => {
    return axios.request({
      url: '/v1/cmdb/sys_parameter/',
      method: 'get',
      params: {
        key,
        value
      }
    })
  }

export const operationsysparameter = (data, meth) => {
  return axios.request({
    url: '/v1/cmdb/sys_parameter/',
    method: meth,
    data
  })
}

export const getinitStatistics = (key, value) => {
    return axios.request({
      url: '/v1/home/initStatistics/',
      method: 'get',
      params: {
        key,
        value
      }
    })
  }
